<template>
  <v-app>
    <!-- App Bar dla desktopów -->
    <v-app-bar
      color="primary"
      dark
      height="250px"
      min-width="1080px"
      scroll-behavior="hide"
      v-if="mobile==false"
    >
      <v-col cols="12">
        <v-row class="align-center">  
          <v-col cols="1"></v-col>
          <v-col cols="10"> 
            <v-row align="center">
              <v-toolbar-title>
                <v-img
                  :src="require('./assets/logo.png')"
                  height="150"
                  contain
                />
              </v-toolbar-title>
            </v-row>
          </v-col>
          <v-col cols="1"> <v-row class="justify-center"><v-btn size="x-large" variant="outlined" color="white" icon="mdi-cart" @click="$router.push('/koszyk')"></v-btn><v-badge color="secondary" v-if="this.getProdInCart.length>0" :content="this.getProdInCart.length"></v-badge></v-row> </v-col>
        </v-row>
        <br />
        <v-row>
          <v-col cols="12">
            <v-card height="50px">
              <v-tabs height="50px" dark align-tabs="center">
                <v-tab color="secondary" @click="$router.push('/')">Strona główna</v-tab>
                <v-tab color="secondary" @click="$router.push('/sklep_koldry')">Sklep</v-tab>
                <v-tab color="secondary" @click="$router.push('/cennik')">Cennik</v-tab>
                <v-tab color="secondary" @click="$router.push('/pielegnacja')">Pielęgnacja</v-tab>
                <v-tab color="secondary" @click="$router.push('/kontakt')">Kontakt</v-tab>
                <!--<v-tab color="secondary" @click="$router.push('/AdminPanel')">Admin</v-tab>-->
              </v-tabs>
            </v-card>
          </v-col>
        </v-row>
      </v-col> 
    </v-app-bar>


    <!-- App Bar dla mobilek -->
    <v-app-bar
      color="primary"
      dark
      scroll-behavior="hide"
      v-if="mobile==true"
    >
      <template v-slot:prepend>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </template>
      <v-app-bar-title>
        <v-img
          :src="require('./assets/logo.png')"
          height="60"
          contain
        />
      </v-app-bar-title>
      <template v-slot:append>
        <v-badge color="secondary" v-if="this.getProdInCart.length>0" :content="this.getProdInCart.length"></v-badge><v-btn icon="mdi-cart" @click="$router.push('/koszyk')"></v-btn>
      </template>
    </v-app-bar>
    <v-navigation-drawer v-if="mobile==true" temporary v-model="drawer">
        <v-list-item>
          <v-img
            :src="require('./assets/logo.png')"
            height="100"
            contain
          />
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link title="Strona główna" @click="$router.push('/')"></v-list-item>
        <v-list-item link title="Sklep" @click="$router.push('/sklep_koldry')"></v-list-item>
        <v-list-item link title="Cennik" @click="$router.push('/cennik')"></v-list-item>
        <v-list-item link title="Pielęgnacja" @click="$router.push('/pielegnacja')"></v-list-item>
        <v-list-item link title="Kontakt" @click="$router.push('/kontakt')"></v-list-item>
    </v-navigation-drawer>

    <v-main v-if="mobile==false" class="bar-main">
        <router-view />
    </v-main>
    <v-main v-if="mobile==true">
        <router-view />
    </v-main>

    <v-snackbar
    v-model="cookieInfoSnack"
    color="primary"
    multi-line
    timeout="6000"
    min-width="1600"
    v-if="mobile==false"
    >
    Strona wykorzystuje pliki Cookies w celu zapewnienia maksymalnej wygody w korzystaniu z naszego sklepu. Jeśli wyrażasz zgodę na zapisywanie informacji, możesz zamknąć powiadomienie krzyżykiem. Jeżeli nie wyrażasz zgody, pliki cookies możesz zablokować w przeglądarce, bądź opuścić stronę.
    <template v-slot:actions>
        <v-btn
        icon="mdi-close"
        color="white"
        @click="cookieInfoSnack = false"
        >            
        </v-btn>
    </template>
    </v-snackbar>

    <v-snackbar
    v-model="cookieInfoSnack"
    color="primary"
    multi-line
    timeout="6000"
    v-if="mobile==true"
    >
    Strona wykorzystuje pliki Cookies w celu zapewnienia maksymalnej wygody w korzystaniu z naszego sklepu. Jeśli wyrażasz zgodę na zapisywanie informacji, możesz zamknąć powiadomienie krzyżykiem. Jeżeli nie wyrażasz zgody, pliki cookies możesz zablokować w przeglądarce, bądź opuścić stronę.
    <template v-slot:actions>
        <v-btn
        icon="mdi-close"
        color="white"
        @click="cookieInfoSnack = false"
        >            
        </v-btn>
    </template>
    </v-snackbar>

    <v-footer
    color='primary'
    dark
    class="stoopka"
    height="200"
    v-if="mobile==false"
    >
      <v-container>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="5">
            <strong>Alpakowy Raj - </strong> 2023 - {{ new Date().getFullYear() }}
          </v-col>
          <v-col cols="5" class="text-caption text-end">
            <p>kontakt@alpakowyraj.pl</p>
            <p>605 909 880</p>
            <a href="https://www.facebook.com/people/Alpakowy-Raj-Kołdry/61553534998486/" class="text-decoration-none text-white">fb.me/alpakowyrajkoldry</a>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="10" class="text-caption">
            <v-card class='text-center' elevation="0" color="primary" height="20">
              <router-link :to="'/'" class="text-decoration-none text-white">Strona Główna</router-link> <v-divider class="border-opacity-75 mx-5" vertical></v-divider>
              <router-link :to="'/sklep'" class="text-decoration-none text-white">Sklep</router-link> <v-divider class="border-opacity-75 mx-5" vertical></v-divider>
              <router-link :to="'/cennik'" class="text-decoration-none text-white">Cennik</router-link> <v-divider class="border-opacity-75 mx-5" vertical></v-divider>
              <router-link :to="'/pielegnacja'" class="text-decoration-none text-white">Pielęgnacja</router-link> <v-divider class="border-opacity-75 mx-5" vertical></v-divider>
              <router-link :to="'/kontakt'" class="text-decoration-none text-white">Kontakt</router-link> <v-divider class="border-opacity-75 mx-5" vertical></v-divider>
              <router-link :to="'/regulamin'" class="text-decoration-none text-white">Regulamin</router-link> <v-divider class="border-opacity-75 mx-5" vertical></v-divider>
              <router-link :to="'/polityka-prywatnosci'" class="text-decoration-none text-white">Polityka Prywatności</router-link>
            </v-card>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="10" class="text-caption">
            <v-card class='text-center' elevation="0" color="primary" height="20">
              <p class="text-caption text-end">Projekt strony: <a href="https://jakubprutkowski.pl" target="_blank" class="text-decoration-none text-secondary">Jakub Prutkowski</a></p>
            </v-card>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </v-container>
    </v-footer>


    <v-footer
    color='primary'
    dark
    v-if="mobile==true"
    >
      <v-container>
        <v-row class="text-center">
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <strong>Alpakowy Raj - </strong> 2023 - {{ new Date().getFullYear() }}
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
        <v-row class="text-center">
          <v-col cols="1"></v-col>
          <v-col cols="10" class="text-caption">
            <p>kontakt@alpakowyraj.pl</p>
            <p>605 909 880</p>
            <a href="https://www.facebook.com/people/Alpakowy-Raj-Kołdry/61553534998486/" class="text-decoration-none text-white">fb.me/alpakowyrajkoldry</a>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
        <v-row class="text-center">
          <v-col cols="12" class="text-caption">
            <v-card class='text-center' elevation="0" color="primary">
              <router-link :to="'/'" class="text-decoration-none text-white">Strona Główna</router-link> <v-divider class="border-opacity-75 mt-2 mx-12"></v-divider>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="text-center">
          <v-col cols="6" class="text-caption">
            <v-card class='text-center' elevation="0" color="primary" height="100">
              <router-link :to="'/sklep'" class="text-decoration-none text-white">Sklep</router-link> <v-divider class="border-opacity-75 my-2 mx-5"></v-divider>
              <router-link :to="'/cennik'" class="text-decoration-none text-white">Cennik</router-link> <v-divider class="border-opacity-75 my-2 mx-5"></v-divider>
              <router-link :to="'/pielegnacja'" class="text-decoration-none text-white">Pielęgnacja</router-link>
            </v-card>
          </v-col>
          <v-col cols="6" class="text-caption">
            <v-card class='text-center' elevation="0" color="primary" height="100">
              <router-link :to="'/kontakt'" class="text-decoration-none text-white">Kontakt</router-link> <v-divider class="border-opacity-75 my-2 mx-5"></v-divider>
              <router-link :to="'/regulamin'" class="text-decoration-none text-white">Regulamin</router-link> <v-divider class="border-opacity-75 my-2 mx-5"></v-divider>
              <router-link :to="'/polityka-prywatnosci'" class="text-decoration-none text-white">Polityka Prywatności</router-link>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="10" class="text-caption">
            <v-card class='text-center' elevation="0" color="primary" height="20">
              <p class="text-caption text-center">Projekt strony: <a href="https://jakubprutkowski.pl" target="_blank" class="text-decoration-none text-secondary">Jakub Prutkowski</a></p>
            </v-card>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<style>
  .bar-main {
    padding-top: 220px;
    min-width: 1080px;
  }
  .stoopka {
    max-height: 200px;
  }
</style>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({
      tab: null,
      mobile: false,
      drawer: false,
      cookieInfoSnack: true,
    }),
    created() {
      this.mobile = this.$vuetify.display.mobile;
      document.title = `${process.env.VUE_APP_TITLE}`;
    },
    computed: {
      ...mapGetters([
        'getProdInCart',
      ]),
    },
  }
</script>
